import $ from 'jquery';
window.menuBreakpoint = 1100;
export default {
	isDesktopMenu() {
		return window.innerWidth >= window.menuBreakpoint;
	},

	setBgAttr() {
		function getEffectiveBackgroundColor(el) {
			// Get the computed style for the current element
			var style = window.getComputedStyle(el);
			var bgColor = style.backgroundColor;

			// Check if the color is transparent or not defined
			var isTransparent =
				bgColor === 'rgba(0, 0, 0, 0)' ||
				bgColor === 'transparent' ||
				bgColor === 'rgba(255, 255, 255, 0)';

			// If transparent and a parent exists, check the parent
			if (isTransparent && el.parentElement) {
				return getEffectiveBackgroundColor(el.parentElement);
			}

			// Return the found color, or white if we've reached the top (most browser defaults)
			return bgColor;
		}

		// Usage
		var siteSections = $('section');
		siteSections.each(function () {
			var bgColor = getEffectiveBackgroundColor(this);
			bgColor = bgColor
				.replaceAll('rgb', '')
				.replaceAll('(', '')
				.replaceAll(')', '')
				.replaceAll(/\s/g, '')
				.replaceAll(',', '-');
			$(this).attr('data-color', 'color-' + bgColor);
		});
	},
	scrollHandler() {
		// Scroll handling for header hide/show on scroll

		var lastScrollTop = $(window).scrollTop();
		var isScrollTicking = false;
		var scrollThreshold = 8;

		function handleHeaderScroll() {
			var st = $(window).scrollTop();
			var scrollDelta = st - lastScrollTop;

			if (Math.abs(scrollDelta) < scrollThreshold) {
				isScrollTicking = false;
				return;
			}

			if (scrollDelta > 0) {
				// Scrolling Down
				$('.header').addClass('hide-effect');
			} else {
				// Scrolling Up
				$('.header').removeClass('hide-effect');
			}
			lastScrollTop = st;
			isScrollTicking = false;
		}

		$(window).on('scroll', function () {
			if (isScrollTicking) {
				return;
			}

			isScrollTicking = true;
			(
				window.requestAnimationFrame ||
				function (callback) {
					setTimeout(callback, 16);
				}
			)(handleHeaderScroll);
		});

		var header = $('.header');
		var sections = $('section');

		var options = {
			// Offset the detection area by the header's height
			rootMargin: '-80px 0px 0px 0px',
			threshold: 0,
		};

		var observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Remove any existing color classes
					var colorScheme = entry.target.getAttribute('data-color');
					header.removeClass(function (index, className) {
						return (className.match(/(^|\s)color-\S+/g) || []).join(' ');
					});
					header.addClass(`color-${colorScheme}`);
				}
			});
		}, options);

		sections.each(function () {
			observer.observe(this);
		});
	},
	init() {
		var self = this;

		function toggleDropdown($dropdownItem) {
			var $button = $dropdownItem.find('.header-dropdown-toggle').first();
			var $dropdownMenu = $dropdownItem.find('.header-dropdown-menu').first();
			var isExpanded = $button.attr('aria-expanded') === 'true';

			if (isExpanded) {
				$button.attr('aria-expanded', false);
				$dropdownItem.removeClass('-dropdown-open');
				$dropdownMenu.hide();
			} else {
				$('.header-dropdown-item').removeClass('-dropdown-open');
				$('.header-dropdown-toggle').attr('aria-expanded', false);
				$('.header-dropdown-menu').hide();

				$button.attr('aria-expanded', true);
				$dropdownItem.addClass('-dropdown-open');
				$dropdownMenu.show();
			}
		}

		this.setBgAttr();
		this.scrollHandler();
		$('.header').removeClass('hide-effect');

		// console.log(
		// 	'Menu module initialized',
		// 	$('#mobile-menu-toggle'),
		// 	$('.header-desktop-nav'),
		// 	$('#mobile-menu-close'),
		// 	$('.nav-toggle')
		// );
		// New mobile menu toggle
		$('#mobile-menu-toggle').on('click', function () {
			var $button = $(this);
			// Keep CSS state classes applied long enough for the full morph.
			var animationMs = 280;
			var previousTimer = $button.data('hamburgerTimer');
			if (previousTimer) {
				clearTimeout(previousTimer);
			}
			var wasExpanded = $button.attr('aria-expanded') === 'true';

			$('.header-desktop-nav').toggleClass('header-hidden');
			$('.header-desktop-nav').toggleClass('header-visible');
			$('.header-featured-nav').toggleClass('header-hidden');
			$('.header-featured-nav').toggleClass('header-visible');
			$('#main-menu').toggleClass('header-overlay');

			if (wasExpanded) {
				// Closing: keep the "open" visual state briefly so we can animate back.
				$button.removeClass('is-opening').addClass('is-open is-closing');
				$button.attr('aria-expanded', 'false');
				var timerId = setTimeout(function () {
					$button.removeClass('is-open is-closing');
					$button.removeData('hamburgerTimer');
				}, animationMs);
				$button.data('hamburgerTimer', timerId);
			} else {
				// Opening
				$button.removeClass('is-closing').addClass('is-open is-opening');
				$button.attr('aria-expanded', 'true');
				var openTimerId = setTimeout(function () {
					$button.removeClass('is-opening');
					$button.removeData('hamburgerTimer');
				}, animationMs);
				$button.data('hamburgerTimer', openTimerId);
			}
			// Set max height of main menu to viewport height minus other header elements
			var viewportHeight = $(window).height();
			var wpadminbarHeight = $('#wpadminbar').outerHeight() || 0;
			var headerTopHeight = $('.header-top').outerHeight() || 0;
			var headerLogoHeight = $('.header-logo').outerHeight() || 0;
			var featuredNavHeight = $('.header-featured-nav').outerHeight() || 0;
			var maxMenuHeight =
				viewportHeight -
				wpadminbarHeight -
				headerTopHeight -
				headerLogoHeight -
				featuredNavHeight +
				5;
			//console.log(viewportHeight, wpadminbarHeight, headerTopHeight, maxMenuHeight);
			$('.header-desktop-nav').css('max-height', maxMenuHeight + 'px');
		});

		// Toggle dropdown on button click
		$('.header-dropdown-toggle').on('click', function () {
			var $dropdownItem = $(this).closest('.header-dropdown-item');
			toggleDropdown($dropdownItem);
		});

		$('.header-dropdown-link').on('click', function (event) {
			if (self.isDesktopMenu()) {
				return;
			}

			var href = ($(this).attr('href') || '').trim();
			if (href !== '#') {
				return;
			}

			var $dropdownItem = $(this).closest('.header-dropdown-item');
			if (!$dropdownItem.length) {
				return;
			}

			event.preventDefault();
			toggleDropdown($dropdownItem);
		});

		// Allow tab navigation for dropdown menu
		// $('.header-dropdown-link').on('focus', function () {
		// 	var $item = $(this).closest('.header-dropdown-item');
		// 	$item.find('.header-dropdown-toggle').attr('aria-expanded', true);
		// 	$item.addClass('-dropdown-open');
		// 	$item.find('.header-dropdown-menu').show();
		// });

		$('.header-dropdown-item').on('focusout', function () {
			var $this = $(this);
			setTimeout(function () {
				if (!$this.find(':focus').length) {
					$this.find('.header-dropdown-toggle').attr('aria-expanded', false);
					$this.removeClass('-dropdown-open');
					$this.find('.header-dropdown-menu').hide();
				}
			}, 100);
		});

		// Close dropdowns when clicking outside
		$(document).on('click', function (event) {
			if (!$(event.target).closest('.header-dropdown-item').length) {
				$('.header-dropdown-item').removeClass('-dropdown-open');
				$('.header-dropdown-toggle').attr('aria-expanded', false);
				$('.header-dropdown-menu').hide();
			}
		});

		// Close dropdowns on escape key
		$(document).on('keydown', function (event) {
			if (event.key === 'Escape' || event.keyCode === 27) {
				$('.header-dropdown-item').removeClass('-dropdown-open');
				$('.header-dropdown-toggle').attr('aria-expanded', false);
				$('.header-dropdown-menu').hide();
			}
		});

		// Hover functionality for dropdown menus
		$('.header-dropdown-item').on('mouseenter', function () {
			//console.log('mouse entered');
			if (!self.isDesktopMenu()) {
				return; // Skip hover functionality on mobile
			}
			var $item = $(this);
			var $button = $item.find('.header-dropdown-toggle');
			var $menu = $item.find('.header-dropdown-menu');

			// Close all other dropdowns first
			$('.header-dropdown-item').not($item).removeClass('-dropdown-open');
			$('.header-dropdown-toggle').not($button).attr('aria-expanded', false);
			$('.header-dropdown-menu').not($menu).hide();

			// Open this dropdown
			$button.attr('aria-expanded', true);
			$item.addClass('-dropdown-open');
			$menu.show();
		});

		$('.header-dropdown-item').on('mouseleave', function () {
			//console.log('mouse left');
			if (!self.isDesktopMenu()) {
				return; // Skip hover functionality on mobile
			}
			var $item = $(this);
			var $button = $item.find('.header-dropdown-toggle');
			var $menu = $item.find('.header-dropdown-menu');

			// Close this dropdown
			$button.attr('aria-expanded', false);
			$item.removeClass('-dropdown-open');
			$menu.hide();
		});

		// Handle focus trap within mobile menu when open
		var focusableElements = $('#main-menu').find('a, input, select, textarea, button'); // Adjust selector as needed
		var lastElement = focusableElements.last();
		var firstElement = focusableElements.first();

		lastElement.on('focusout', function () {
			// Use a small timeout to ensure the browser has processed the focusout
			// before attempting to set focus again, preventing potential race conditions.
			setTimeout(function () {
				if (self.isDesktopMenu()) {
					return; // Skip focus trap on desktop
				}
				// Check if focus is still outside the desired elements
				// (e.g., if the user clicked elsewhere on the page)
				if (!focusableElements.is(':focus')) {
					firstElement.focus();
				}
			}, 10);
		});

		function resizeHandler() {
			if (self.isDesktopMenu()) {
				// Close all dropdowns
				$('.header-dropdown-item').removeClass('-dropdown-open');
				$('.header-dropdown-toggle').attr('aria-expanded', false);
				$('.header-dropdown-menu').hide();
				$('.header-desktop-nav').removeClass('header-hidden');
				$('.header-featured-nav').removeClass('header-hidden');
			}
		}

		$(window).on('resize', function () {
			resizeHandler();
		});

		$(window).on('load', function () {
			// Add -hiden class to desktop nav by default on load
			if (!self.isDesktopMenu()) {
				$('.header-desktop-nav').addClass('header-hidden');
				$('.header-featured-nav').addClass('header-hidden');
			}
			resizeHandler();
		});
	},
};
